/** Related comparisons shown under a comparison page. */
export const RELATED_COMPARISON_COUNT = 3;

/** Competitor logos stacked in the index hero. */
export const HERO_LOGO_STACK_COUNT = 4;

/** Point lists render as a card grid only within this size range; longer lists stay prose. */
export const MIN_POINT_CARDS = 2;
export const MAX_POINT_CARDS = 6;

/** Top band (in px) the active-section observer treats as "under the sticky nav". */
export const SECTION_NAV_OBSERVER_TOP = 140;

/** Query param + session key that switch comparisons to the agency audience. */
export const THIRD_PARTY_PARAM = "3rdparty";

/** Shown when the CMS fetch fails; the real error is only logged. */
export const LOAD_ERROR_MESSAGE = "Something went wrong loading this page. Try again in a moment.";

/** Closing CTA copy for the agency audience; the direct audience keeps the shared defaults. */
export const AGENCY_CTA = {
  title: "Ready to elevate your agency's event planning?",
  description: "Join leading agencies using Nowadays to deliver exceptional events for their clients.",
  primaryButtonText: "Schedule an agency demo",
};
